module.exports = __webpack_public_path__ + "img/content9.3b25baf4.png";